import store from '@/store'

export const pageLoader = ({next}, value) => {
    store.commit('app/PAGE_LOADER', value);
    typeof next == 'function' && next()
}


export const isAuthenticated = async (to, from, next)=>{
  const params = new URLSearchParams(to.query);
  const routeAccountId = params.get('account_id') || null;
  if(to.meta.isPublicAuthenticatedPage){
    next()
  } else{
    if(routeAccountId){
      store.commit("session/setAccountId", routeAccountId)
    }
    await store.dispatch('session/refresh')
    if(store.getters['session/loggedIn']){
      next()
    } else{
      next('/unauthenticated')
    }
  }
}
